import React from 'react'

const HorizontalSlider = () => {
  return (
    <div className='slider-box'>
      <div className='slider-handle'></div>
    </div>
  )
}

export default HorizontalSlider;